import React from 'react';
import { CheckIcon, DownloadIcon, MailCheckIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Field } from './ui/Field';
import { guideChecklist } from '../data/content';
import { useLeadForm } from '../hooks/useLeadForm';
const GUIDE_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/fbd32b7e-33ba-4d41-a277-4b893223eae5.jpg';
export function LeadMagnet() {
  const {
    fields,
    errors,
    status,
    setField,
    submit
  } = useLeadForm({
    require: ['name', 'email']
  });
  const onSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    void submit();
  };
  return <section id="guide" className="w-full bg-royal-800 py-20 text-white lg:py-28" data-id="element-87" data-mp="2qzilybuxd5s8">
      <div className="mx-auto grid w-full max-w-7xl gap-14 px-5 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-20 lg:px-8" data-id="element-88" data-mp="2m1h1pnlrj0f6">
        <div data-id="element-89" data-mp="1fly1pz3u2zq4">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-turq-300" data-id="element-90" data-mp="1fmpxpb1cezgx">Free 12-page guide</p>
          <h2 className="mt-4 font-display text-4xl leading-tight tracking-tight lg:text-5xl" data-id="element-91" data-mp="1akqv43dfg6l1">
            Don&apos;t book anything until you&apos;ve read this
          </h2>
          <p className="mt-5 max-w-lg text-lg leading-relaxed text-white/75" data-id="element-92" data-mp="9wa6oq0wixbs">
            The Informed Patient&apos;s Guide to Non-Surgical Lifting — written with certified providers, so you
            walk into your consultation knowing exactly what to ask.
          </p>
          <ul className="mt-8 space-y-3" data-id="element-93" data-mp="3icv6phbk2g2r">
            {guideChecklist.map(item => <li key={item} className="flex items-start gap-3 text-[15px] text-white/85" data-id="element-94" data-mp="3n3v5yt85da8f">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-turq-300" aria-hidden="true" data-id="element-95" data-mp="39cov60zf3q68" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="relative rounded-3xl bg-white/5 p-6 ring-1 ring-white/15 sm:p-8" data-id="element-96" data-mp="3e9fd6tus8vua">
          <img src={GUIDE_IMAGE} alt="Cover of the Informed Patient's Guide to Non-Surgical Lifting" className="mx-auto -mt-16 mb-6 h-36 w-36 rounded-2xl object-cover shadow-[0_24px_60px_-24px_rgba(0,0,0,0.6)] sm:h-44 sm:w-44" data-id="element-97" data-mp="2zglwx67osbok" />
          {status === 'success' ? <div className="py-6 text-center" role="status" data-id="element-98" data-mp="2ggfpfm2613yx">
              <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-turq-400 text-ash-900" data-id="element-99" data-mp="2bjz04oj8cjk9">
                <MailCheckIcon className="h-7 w-7" aria-hidden="true" data-id="element-100" data-mp="26hzz3laypyqh" />
              </span>
              <h3 className="mt-5 font-display text-2xl" data-id="element-101" data-mp="3473a77x6jo2w">Check your inbox</h3>
              <p className="mx-auto mt-2 max-w-sm text-sm leading-relaxed text-white/75" data-id="element-102" data-mp="2za344x0bylbs">
                We sent the guide to <span className="font-semibold text-white" data-id="element-103" data-mp="2u8449x3su6jl">{fields.email}</span>. It usually
                lands within a minute — check promotions if you don&apos;t see it.
              </p>
            </div> : <form onSubmit={onSubmit} noValidate className="flex flex-col gap-4" data-id="element-104" data-mp="1is5nt86aki8c">
              <Field label="First name" value={fields.name} onChange={v => setField('name', v)} placeholder="Jane" autoComplete="given-name" error={errors.name} onDark data-id="element-105" data-mp="1du472twc8v01" />
              <Field label="Email address" type="email" inputMode="email" value={fields.email} onChange={v => setField('email', v)} placeholder="jane@email.com" autoComplete="email" error={errors.email} onDark data-id="element-106" data-mp="3a9e9221qa6s" />
              <Button type="submit" variant="accent" size="lg" disabled={status === 'loading'} className="mt-1 w-full" data-id="element-107" data-mp="m3damv6nf153">
                {status === 'loading' ? 'Sending…' : 'Send me the free guide'}
                {status !== 'loading' && <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-108" data-mp="2nv9jty5cfywp" />}
              </Button>
              <p className="text-center text-xs text-white/55" data-id="element-109" data-mp="2ssrwnzmhey9z">
                Instant delivery. Unsubscribe anytime. We never sell your information.
              </p>
            </form>}
        </div>
      </div>
    </section>;
}